export default __webpack_public_path__ + "static/media/img-0163-italy-half-face.b202a2e8.png";